import ParticipantAddForm from "./ParticipantAddForm";
import ParticipantAddHeader from "./ParticipantAddHeader";
import { Box, Collapse } from "@mui/material";
import { useParticipantAddForm } from "../../../hooks/useParticipantAddForm";

/**
 * Główny komponent dodawania zawodnika
 * Zgodny z zasadą pojedynczej odpowiedzialności - tylko orkiestracja
 * Separacja logiki od prezentacji - logika w hooku, prezentacja w podkomponentach
 */
export default function ParticipantAdd({ disabled = false }: { disabled?: boolean }) {
  const {
    formData,
    formErrors,
    infoMessage,
    errorMessage,
    isExpanded,
    handleFieldChange,
    handleFormSubmit,
    toggleExpanded,
  } = useParticipantAddForm();

  return (
    <Box sx={{ mb: 3 }}>
      <ParticipantAddHeader
        isExpanded={isExpanded}
        disabled={disabled}
        onToggleExpanded={toggleExpanded}
      />

      <Collapse in={isExpanded}>
        <ParticipantAddForm
          formData={formData}
          formErrors={formErrors}
          disabled={disabled}
          onFieldChange={handleFieldChange}
          onSubmit={handleFormSubmit}
          infoMessage={infoMessage}
          errorMessage={errorMessage}
        />
      </Collapse>
    </Box>
  );
}
